import React from 'react';
import { motion } from 'framer-motion';
import { useLocation, Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

function ErrorPage() {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const queryMessage = queryParams.get('message');

	let error;
	if (!queryMessage) {
		error = location.state?.error || {
			status: queryParams.get('status') || 404,
			message: queryMessage || 'Page not found',
			details: queryParams.get('details') || 'The page you are looking for might have been removed or is temporarily unavailable.'
		};
	} else {
		error = { status: null, message: queryMessage, details: '' };
	}

	const getErrorTitle = (status) => {
		switch (status) {
			case 401: return 'Unauthorized';
			case 403: return 'Forbidden';
			case 404: return 'Not Found';
			case 500: return 'Server Error';
			default: return 'Error';
		}
	};

	return (
		<motion.div
			className="min-h-[60vh] flex items-center justify-center"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.4 }}
		>
			<div className="text-center max-w-sm">
				<motion.div
					className="mb-6 text-5xl font-bold text-white/10"
					initial={{ scale: 0.8, opacity: 0 }}
					animate={{ scale: 1, opacity: 1 }}
					transition={{ delay: 0.1 }}
				>
					{error.status || '?'}
				</motion.div>

				<h1 className="text-2xl font-bold text-white mb-3 tracking-tight">
					{getErrorTitle(error.status)}
				</h1>

				<div className="bg-white rounded-xl p-5 mb-8 shadow-card-hover border border-gray-100">
					<p className="text-gray-800 text-sm mb-1 font-medium">{error.message}</p>
					{error.details && <p className="text-gray-400 text-xs">{error.details}</p>}
				</div>

				<Link
					to="/"
					className="inline-flex items-center gap-2 bg-yellow-300 text-gray-900 px-5 py-2.5 rounded-lg text-xs font-bold uppercase tracking-wider hover:bg-yellow-200 transition-colors shadow-glow-yellow"
				>
					<FaHome className="text-[10px]" />
					Return Home
				</Link>
			</div>
		</motion.div>
	);
}

export default ErrorPage;
